import { authorizedApi } from '../../utils/api';

export const getOrderList = (token, CurrPage = 1, per_page = 10) => {
  return authorizedApi(token).get(`/orders?page=${CurrPage}&per_page=${per_page}&is_listing=yes`);
};

export const getOrders = (token, paramString, config = {}) => {
  return authorizedApi(token).get(`/orders?${paramString}`, config);
};

export const getSSN = (data, token) => {
  return authorizedApi(token).post(`/fetch/ssn`, data);
};

export const reverifySSN = (data, token) => {
  return authorizedApi(token).post(`/reverify-tincheck-data`, data);
};

export const getDecryptedBankAcc = (data, token) => {
  return authorizedApi(token).post(`/fetch/decrypted/string`, data);
};

export const getOrderTypes = (token, clientId, officeId, config = {}) => {
  return authorizedApi(token).get(
    `/admin/orders/types?client_id=${clientId}&client_office_id=${officeId}`,
    config
  );
};

export const getOrder = (id, token) => {
  return authorizedApi(token).get(`/admin/orders/${id}`);
};

export const getOrderLabel = (companyId, token) => {
  return authorizedApi(token).get(`/order/orders/labels/${companyId}`);
};

export const addOrder = (data, token) => {
  return authorizedApi(token).post(`/admin/orders`, data);
};

export const duplicateOrder = (orderId, data, token) => {
  return authorizedApi(token).post(`/admin/orders/${orderId}/duplicate`, data);
};

export const archiveOrder = (data, token) => {
  return authorizedApi(token).post(`/admin/order/change/record/status`, data);
};

export const markOrderFraud = (orderId, data, token) => {
  return authorizedApi(token).post(`/admin/orders/${orderId}/mark-fraud`, data);
};

export const unmarkOrderFraud = (orderId, token) => {
  return authorizedApi(token).post(`/admin/orders/${orderId}/unmark-fraud`);
};

export const updateOrder = (id, data, token) => {
  return authorizedApi(token).put(`/admin/orders/${id}`, data);
};

export const addParticipants = (data, token) => {
  return authorizedApi(token).post(`/admin/add/participant`, data);
};

export const addSellerEnteredAgent = (orderId, participantId, data, token) => {
  return authorizedApi(token).post(
    `/admin/orders/${orderId}/participants/${participantId}/seller-agent`,
    data
  );
};

export const dismissSellerEnteredAgent = (orderId, participantId, data, token) => {
  return authorizedApi(token).post(
    `/admin/orders/${orderId}/participants/${participantId}/seller-agent/dismiss`,
    data
  );
};

export const updateParticipant = (id, data, token) => {
  return authorizedApi(token).put(`/admin/update/participant/${id}`, data);
};

export const activateParticipantInviteLink = (data, token) => {
  return authorizedApi(token).post(`/admin/update/participant/form/link/status`, data);
};

export const updateParticipantFormFlow = (data, token) => {
  return authorizedApi(token).post(`/participant/change/form/flow`, data);
};
export const deleteParticipant = (id, token) => {
  return authorizedApi(token).delete(`/admin/order/participant/${id}`);
};
export const updateAdditionalParticipant = (data, token) => {
  return authorizedApi(token).post(`/update/additional/participant`, data);
};

export const getClientList = (token) => {
  return authorizedApi(token).get(`/admin/get/clients`);
};

export const getPropertyDetails = (data, token) => {
  return authorizedApi(token).get(`/order/property/detail/source`, { params: data });
};

export const getUsersOptions = (data, token) => {
  return authorizedApi(token).get(`/admin/get/client/users`, { params: data });
};

export const getParticipantOptions = (data, token) => {
  return authorizedApi(token).get(`/admin/orders/all/participant`, { params: data });
};

export const getParticipantStatusOptions = (token) => {
  return authorizedApi(token).get(`/admin/participant/form/status/list`);
};

export const reassignOrder = (data, token) => {
  return authorizedApi(token).post(`/admin/reassign/order`, data);
};

export const getClientUserByClientId = (id, token) => {
  return authorizedApi(token).get(`/admin/client/users/${id}`);
};

export const fetchLinkStatus = (uuid, orderId, token) => {
  return authorizedApi(token).get(
    `/admin/participant/source/pull?participant_uuid=${uuid}&order_id=${orderId}`
  );
};

export const searchPropertyDetails = (token, data) => {
  return authorizedApi(token).post(`/admin/property/detail`, data);
};

export const createOrderFromCSV = (data, config, token) => {
  return authorizedApi(token).post(`/import/orders`, data, config);
};

export const manualVerification = (data, token) => {
  return authorizedApi(token).post(`/participant/id/manual/verify`, data);
};

export const acceptLienInformation = (data, token) => {
  return authorizedApi(token).post(`/update/lien/data/status`, data);
};

export const getDocList = (orderId, userParticipantTypeId, token) => {
  return authorizedApi(token).get(
    `/participant/additional-documents/${orderId}/${userParticipantTypeId}`
  );
};
export const downloadOrderDetailsPdf = (id, token) => {
  return authorizedApi(token).get(`/admin/order/detail/pdf/${id}`);
};

export const generateEscrowNumber = (data, token) => {
  return authorizedApi(token).get(`/admin/order/sequential/escrow/number`, { params: data });
};

export const checkEscrowNumber = (data, token) => {
  return authorizedApi(token).post(`/admin/orders/check-escrow-number`, data);
};

export const downloadAdditionalDocument = (documentId, token) => {
  return authorizedApi(token).get(`/admin/participant/additional/document/${documentId}`);
};

export const getDocumentDetails = (params, token) => {
  return authorizedApi(token).get(`/admin/participant/uploaded/document/list`, { params });
};

export const generateDeedDocument = (params, token) => {
  return authorizedApi(token).get(`/admin/participant/deed/document`, { params });
};

export const downloadParticipantDocuments = (data, token) => {
  return authorizedApi(token).post(`/admin/participant/download/documents/zip`, data);
};